const BASE_URL = process.env.REACT_APP_BASE_URL;
export default {
    BASE_URL:BASE_URL,
    profesionales: BASE_URL+'profesionales/',
    categorias: BASE_URL+'categorias/',
}


// WEBPACK FOOTER //
// ./src/api/api.js